<template>
  <div class="invoice-view">
    <v-card flat>
      <ReportViewBar
        :start="dateTime.start"
        :end="dateTime.end"
        :title="`Expense By Date`"
        :showDate="true"
      />
      <v-card-text>
        <v-layout row wrap class="no-print" justify-end>
          <v-flex xs12 md3>
            <DateTimePicker
              :range="true"
              v-model="dateTime"
              :initStartDate="start"
              :initEndDate="end"
              @submit="getList()"
            />
          </v-flex>
        </v-layout>
      </v-card-text>

      <v-progress-linear v-if="isLoading" :indeterminate="true"></v-progress-linear>
      <v-container fluid v-else>
        <ExpenseReport
          :selectedRange="selectedRange"
          :expenses="expenses"
          :showTotal="true"
        />
      </v-container>
    </v-card>
  </div>
</template>

<script>
import expenseService from '../service.js'

import ReportViewBar from '@/components/ReportViewBar.vue';
import ExpenseReport from './ExpenseReport';
// import expenseService from '@/modules/Expense/service.js'

const DateTimePicker = () => import('@/components/DateTimePicker')

export default {
  props: ['location'],
  data() {
    return {
      expenses: [],
      expenseUnGroup: [],
      isLoading: true,
      selectedRange: 'thisMonth',
      type: '',
      locaitonId: '',
      start: this.$moment().startOf('month'),
      end: this.$moment().endOf('day'),
      dateTime: {
        start: this.$moment()
          .startOf('day')
          .toISOString(),
        end: this.$moment()
          .endOf('day')
          .toISOString(),
      },
    }
  },
  components: {
    ReportViewBar,
    ExpenseReport,
    DateTimePicker,
  },
  created() {
    const { start, end, range, type, locaitonId } = this.$route.query
    this.type = type
    this.locaitonId = locaitonId
    this.dateTime.start = start
    this.dateTime.end = end
    console.log('dateTime3213', this.dateTime, this.$route.query)
    this.selectedRange = range
    this.getList()
  },
  watch: {
    selectedGroup(val) {
      this.groupBy(val.key)
    },
  },
  methods: {
    groupBy(key) {
      switch (key) {
        case 'payee':
          this.getList()
          break
        case 'employee':
          this.getByEmployee()
          break
        default:
      }
    },
    getList() {
      this.getExpense()
    },
    getByEmployee() {
      //   this.isLoading = true;
      //   const where = {
      //     start: this.dateTime.start,
      //     end: this.dateTime.end,
      //   };
      //   return expenseService.getReportByPayee(where).then(response => {
      //     console.log('getEmployee.data;', response.data);
      //     this.expenses = response.data.Payees;
      //     //this.expensesUnGroup = response.data;
      //     this.expenses.map(payee => {
      //       payee.total = 0;
      //       payee.date = '';
      //       payee.Expenses.map(expense => {
      //         payee.total += parseFloat(expense.amount);
      //         payee.date = expense.createdAt;
      //         payee.note = expense.note;
      //       });
      //       this.expenses.Expenses.Employees.map(employee => {
      //         employee.name = employee.name;
      //       });
      //       console.log('pd', employee);
      //     });
      //     this.isLoading = false;
      //   });
    },
    getExpense() {
      this.isLoading = true

      const where = {
        start: this.dateTime.start,
        end: this.dateTime.end,
        type: this.$route.query.type,
        locaitonId: this.$route.query.locationId,
      }
      expenseService.getExpenseList(where).then(response => {
        console.log('getExpenseList.data;', response.data)
        this.expenses = response.data.Expenses
        this.isLoading = false
      })
    },
  },
}
</script>

<style>
@media print {
  container {
    height: 100%;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden;
  }
  .no-print {
    display: none;
  }
  .detailBox {
    overflow: visible;
    height: 100%;
  }
  * {
    background: 0 0 !important;
    color: #000 !important;
    box-shadow: none !important;
    text-shadow: none !important;
  }
}
.paidImg {
  position: absolute;
  left: 40%;
  top: 10%;
}

.signature {
  margin-top: 100px;
}
.center {
  background-color: white;
  margin: auto;
  width: 100%;
}
/* table.v-table tbody td {
  height: 25px !important;
} */
</style>
